<template>
  <div>
    <div class="text-end ma-6">
      <v-btn @click="dialog = !dialog" medium color="primary">
        <v-icon left>mdi-pencil</v-icon>
        Cập nhật
      </v-btn>
    </div>
    <v-card class="ma-6 pa-6" outlined>
      <div>
        <span>
          Nhắc nhở HS sau tiết học:
        </span>
        <span class="font-weight-bold">
          {{ slot | _get('classNote.data.classReminder', '') }}
        </span>
      </div>
    </v-card>
    <ClassReminderUpdateDialog :state="dialog" :classReminder="$_get(slot, 'classNote.data.classReminder')" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ClassReminderUpdateDialog from '@/modules/classNote/teacherSide/ClassReminderUpdateDialog.vue'
export default {
  data() {
    return {
      dialog: null
    }
  },
  components: {
    ClassReminderUpdateDialog
  },
  methods: {},
  computed: { ...mapState('ClassNoteDetail', ['slot']) }
}
</script>

<style></style>
